<template>
  <div class="container-fluid">
    <div class="loading" v-if="isLoading">Loading&hellip;</div>
    <div class="view-header my-4">
      <div class="view-header__main">
        <div class="view-header__info">
          <h1 class="view-header__title">Proveedores</h1>
          <p class="view-header__subtitle">Administrá los proveedores de la sucursal.</p>
        </div>
        <div class="view-header__actions">
          <button type="button" class="btn view-header__btn" @click="exportarCSV()">
            <i class="bi bi-download"></i>
            Exportar CSV
          </button>
          <button type="button" class="btn view-header__btn view-header__btn--primary" @click="newProvider">
            <i class="bi bi-truck"></i>
            Nuevo proveedor
          </button>
        </div>
      </div>
    </div>
    <!-- FILTROS -->
    <div class="filters-panel">
      <div class="filters-panel__section">
        <div class="filters-panel__section-title">
          <i class="bi bi-search"></i>
          Buscador
        </div>
        <div class="filters-panel__row">
          <div class="filters-panel__field">
            <input v-model="doSearch" type="search" class="form-control" placeholder="Buscar proveedor...">
          </div>
        </div>
      </div>
    </div>
    <!-- TABLA -->
    <div class="data-table">
      <vdtnet-table
        ref="table"
        :fields="fields"
        :opts="opts"
        :selectCheckbox="0"
        container-class-name="table-responsive"
        class-name="table mb-0"
        @viewCC="viewCCMethod"
        @edit="changeProviderId"
        @delete="deleteProvider"
      />
    </div>
    <NuevoProveedor
      v-if="showModal"
      :providerId="providerIdParent"
      @edit="changeProviderId"
      @confirmsave="refreshTable()"
      @close="showModal = false"
    />
  </div>
</template>

<script>
import VdtnetTable from '@/components/global/VdtnetTable.vue';
import NuevoProveedor from "./Nuevo-proveedor.vue";

export default {
  components: {
    VdtnetTable,
    NuevoProveedor,
  },
  data: function () {
    return {
      showModal: false,
      providerIdParent: null,
      doSearch: "",
      isLoading: false,
      opts: {
        language: {
          url: '//cdn.datatables.net/plug-ins/1.13.4/i18n/es-ES.json',
        },
        ajax: {
          url: process.env.VUE_APP_BASE_URL + "/api/providers/list",
          type: "GET",
          headers: { Authorization: "Bearer " + localStorage.getItem("token") },
        },
        processing: false,
        pageLength: 15,
        searching: true,
        searchDelay: 100,
        destroy: true,
        ordering: true,
        lengthChange: true,
        serverSide: true,
        fixedHeader: true,
        autoWidth: false,
      },
      fields: {
        name: {
          label: "Nombre",
          render: (data, type) =>
            type === 'display' ? `<span class="data-table__primary">${data}</span>` : data,
        },
        cuit: { label: "CUIT", width: "130px" },
        phone_1: { label: "Teléfono", width: "130px" },
        phone_2: { label: "Celular", width: "130px" },
        actions: {
          isLocal: true,
          label: "Acciones",
          width: "140px",
          align: "right",
          defaultContent: `
            <div class="table-action-group">
              <button data-action="viewCC" class="table-action-btn" type="button" title="Ver cuenta corriente">CC</button>
              <button data-action="edit" class="table-action-btn" type="button" title="Editar">
                <i class="bi bi-pencil"></i>
              </button>
              <button data-action="delete" class="table-action-btn" type="button" title="Eliminar">
                <i class="bi bi-trash"></i>
              </button>
            </div>
          `,
        },
      },
    };
  },
  mounted() {
    this.$nextTick(() => {
      const dt = this.$refs.table && this.$refs.table.dataTable;
      if (!dt) return;
      dt.on('preXhr.dt', () => { this.isLoading = true; });
      dt.on('xhr.dt', () => { this.isLoading = false; });
    });
  },
  watch: {
    doSearch(newValue, oldValue) {
      if (newValue.length >= 4 || oldValue.length >= 4) {
        this.$refs.table.search(this.doSearch);
      }
      if (newValue === "" && oldValue.length > 0) {
        this.$refs.table.search(this.doSearch);
      }
    },
  },
  methods: {
    refreshTable() {
      if (this.$refs.table !== undefined) this.$refs.table.reload();
    },
    newProvider() {
      this.providerIdParent = null;
      this.showModal = true;
    },
    viewCCMethod(data) {
      this.$router.push({ name: 'Detalle de cuenta corriente de proveedor', params: { providerId: data.id } });
    },
    changeProviderId(data) {
      this.providerIdParent = data.id;
      this.showModal = true;
    },
    deleteProvider(data) {
      if (!confirm("¿Está seguro que desea borrar este proveedor?")) return;
      this.$http.post("/api/providers/delete", { id: data.id }).then((response) => {
        if (response.data.code === 201) this.refreshTable();
      });
    },
    exportarCSV() {
      this.$http.post(process.env.VUE_APP_BASE_URL + "/api/providers/exportCSV");
    },
  },
};
</script>
